/**
 * @generated SignedSource<<7af3195b2b88b0301c8e7b5803617ade>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteGoogleDriveProjectFileLinkInput = {
  id?: string | null;
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteGoogleDriveProjectFileLinkMutation$variables = {
  input: DeleteGoogleDriveProjectFileLinkInput;
};
export type deleteGoogleDriveProjectFileLinkMutation$data = {
  readonly deleteGoogleDriveProjectFileLink: {
    readonly deletedGoogleDriveFileId: string | null;
  } | null;
};
export type deleteGoogleDriveProjectFileLinkMutation = {
  variables: deleteGoogleDriveProjectFileLinkMutation$variables;
  response: deleteGoogleDriveProjectFileLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGoogleDriveProjectFileLinkPayload",
    "kind": "LinkedField",
    "name": "deleteGoogleDriveProjectFileLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGoogleDriveFileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d393edb7b68b36eb449c467d2c501881",
    "id": null,
    "metadata": {},
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGoogleDriveProjectFileLinkMutation(\n  $input: DeleteGoogleDriveProjectFileLinkInput!\n) {\n  deleteGoogleDriveProjectFileLink(input: $input) {\n    deletedGoogleDriveFileId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e50e749aad6b9358b5d072cb415a82ac";

export default node;
